<script setup>

</script>

<template>
    <div class="border p-4">

    </div>
</template>

<style scoped lang="scss">

</style>
